import { useTheme } from "../context/ThemeContext";
import { useEffect } from "react";

function Services() {
  const { theme } = useTheme();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container mx-auto my-8 px-4">
      <h2
        className={`text-5xl md:text-6xl font-light mb-6 ${theme.text} font-handwriting`}
      >
        Meine Leistungen
      </h2>

      <div className="grid md:grid-cols-2 gap-8 mb-12">
        <div className="space-y-8">
          <p className="text-lg leading-relaxed text-slate-700">
            Als systemische Beraterin unterstütze ich Sie bei verschiedenen
            Lebensthemen und Herausforderungen. Meine Beratung ist
            lösungsorientiert und ressourcenaktivierend - gemeinsam finden wir
            Wege zu positiver Veränderung.
          </p>

          <div className={`${theme.box} p-6 rounded-lg shadow-lg`}>
            <h3 className="text-xl font-semibold mb-4 text-slate-800">
              Erstgespräch
            </h3>
            <p className="text-lg text-slate-700">
              In einem unverbindlichen und kostenlosen Erstgespräch lernen wir
              uns kennen und besprechen Ihr Anliegen. Hier können Sie einen
              ersten Eindruck von meiner Arbeitsweise gewinnen.
            </p>
          </div>

          <div className={`${theme.box} p-8 rounded-lg shadow-lg`}>
            <h3 className="text-2xl font-semibold mb-6 text-slate-800">
              Meine Schwerpunkte
            </h3>
            <ul className="space-y-3 text-lg text-slate-700">
              <li>• Persönlichkeitsentwicklung & Selbstfindung</li>
              <li>• Selbstbewusstsein und Selbstwertgefühl stärken</li>
              <li>• Eigene Muster erkennen, hinterfragen und reflektieren</li>
              <li>• Beziehungs- und Bindungsthemen klären</li>
              <li>• Aktuelle Krisen bewältigen</li>
              <li>• Wendepunkte und Veränderungen meistern</li>
              <li>• Neuorientierung im privaten oder beruflichen Kontext</li>
              <li>• Erziehungsfragen reflektieren</li>
            </ul>
          </div>
        </div>

        <div className="flex items-center justify-center">
          <img
            src="/images/walk.jpg"
            alt="Walk & Talk Beratung in der Natur"
            className="rounded-lg shadow-lg h-[800px] object-cover"
          />
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-8 mb-12">
        <div
          className={`bg-gradient-to-br ${theme.gradient} p-8 rounded-lg shadow-lg text-white`}
        >
          <h3 className="text-2xl font-bold mb-6">Walk & Talk – Beratung</h3>
          <p className="text-lg mb-6">
            Meine Beratung findet draußen in der Natur statt.
          </p>
          <p className="text-lg mb-4">
            Es ist wissenschaftlich erwiesen, dass Bewegung in der Natur:
          </p>
          <ul className="space-y-2 text-lg mb-6">
            <li>✔ die Gedanken klärt</li>
            <li>✔ die Kreativität fördert</li>
            <li>✔ Stress reduziert</li>
            <li>✔ eine entspannte und offene Gesprächsatmosphäre schafft</li>
          </ul>
          <p className="text-lg mb-6">
            Während unseres gemeinsamen Spaziergangs nutzen wir die Natur als
            Reflexionsraum. Schritt für Schritt entstehen neue Perspektiven und
            Lösungsansätze.
          </p>
        </div>

        <div
          className={`bg-gradient-to-br ${theme.gradient} p-8 rounded-lg shadow-lg text-white`}
        >
          <h3 className="text-2xl font-bold mb-6">Online-Beratung</h3>
          <p className="text-lg mb-6">
            Die Online-Beratung bietet Ihnen die Möglichkeit, professionelle
            Unterstützung bequem von zu Hause aus in Anspruch zu nehmen.
          </p>
          <p className="text-lg mb-4">Vorteile der Online-Beratung:</p>
          <ul className="space-y-2 text-lg mb-6">
            <li>✔ Ortsunabhängig - keine Anfahrtswege</li>
            <li>✔ Zeitlich flexibel</li>
            <li>✔ In vertrauter Umgebung</li>
            <li>✔ Technisch einfach umsetzbar</li>
          </ul>
          <p className="text-lg mb-6">
            Die Beratung findet per Videochat statt und ist genauso vertraulich
            und professionell wie ein persönliches Gespräch.
          </p>
        </div>
      </div>

      <div className="mt-16 bg-blue-50 p-8 rounded-lg shadow-lg">
        <h3 className="text-2xl font-semibold mb-6 text-slate-800">
          Organisatorisches
        </h3>

        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <h4 className="text-xl font-semibold mb-4 text-slate-800">
              Zur Walk & Talk Beratung
            </h4>
            <ul className="space-y-3 text-lg text-slate-700">
              <li>
                • Die Beratung findet bei jedem Wetter statt – bitte
                entsprechend kleiden.
              </li>
              <li>
                • Falls notwendig, kann eine telefonische Sitzung als
                Alternative vereinbart werden.
              </li>
              <li>• Den Treffpunkt legen wir gemeinsam fest.</li>
              <li>• Hunde dürfen gerne mitgebracht werden.</li>
            </ul>
          </div>

          <div>
            <h4 className="text-xl font-semibold mb-4 text-slate-800">
              Zur Online-Beratung
            </h4>
            <ul className="space-y-3 text-lg text-slate-700">
              <li>
                • Kontaktaufnahme per E-Mail oder Telefon zur Terminvereinbarung
              </li>
              <li>• Sie erhalten einen Link für die Videokonferenz</li>
              <li>
                • Zum vereinbarten Termin klicken Sie einfach auf den Link
              </li>
              <li>
                • Das Gespräch findet in einem geschützten virtuellen Raum statt
              </li>
            </ul>
            <h4 className="text-xl font-semibold mt-6 mb-3 text-slate-800">
              Technische Voraussetzungen:
            </h4>
            <ul className="space-y-2 text-slate-700">
              <li>• Stabile Internetverbindung</li>
              <li>• Computer/Tablet mit Kamera und Mikrofon</li>
              <li>• Ruhiger, ungestörter Raum</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
